import React from "react";
import AppRouter from "./routes/AppRouter";
import { ThemeProvider } from "./contexts/ThemeContext";
import { NotificationProvider } from "./contexts/NotificationToast";

const App = () => {
  return (
    <ThemeProvider>
      <NotificationProvider>
        <AppRouter />
      </NotificationProvider>
    </ThemeProvider>
  );
};

export default App;
